<div class="wrap" id="licence">
  <a [href]="urlPdf" class="upload">télécharger ma licence</a>
  <!-- <iframe [src]="pdf" frameborder="0" width="100%" height="50%" *ngIf="pdf"></iframe> -->
  <div class="loading" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <div class="img" *ngIf="!loading ">
    <a [href]="urlPdf" *ngIf="responseLicence"><img [src]="urlPng" alt="ma_licence"></a>
    <p class="no_licence" *ngIf="!responseLicence">Votre licence n'est plus valide</p>
  </div>

</div>